module.exports = __webpack_public_path__ + "static/img/Dragonfly_spacecraft.e24dc46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dragonfly_spacecraft.jpg
// module id = 71Ee
// module chunks = 0